import { array, object, string } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

const validationSchema = object().shape({
  carePlanIcd10Codes: array().of(
    object().shape({
      icd10CodeId: string().nullable().required('Field is required'),
      typeId: string().required('Field is required'),
    }),
  ),
});

export default yupResolver(validationSchema);
